import { Component } from "@angular/core";
import { SpartaxFormStepBaseComponent } from "../spartax-form-step-base";

@Component({
  selector: 'app-spartax-procedure',
  templateUrl: './spartax-procedure.component.html',
  styleUrls: ['./spartax-procedure.component.scss'],
})
export class SpartaxProcedureComponent extends SpartaxFormStepBaseComponent { }